import { useState, useEffect, useRef } from "react";

export default function CounterSection() {
  const [count, setCount] = useState(0);
  const [triggered, setTriggered] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !triggered) {
          setTriggered(true);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [triggered]);

  useEffect(() => {
    if (!triggered) return;
    const target = 2000;
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    const interval = duration / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, interval);
    return () => clearInterval(timer);
  }, [triggered]);

  return (
    <section ref={ref} data-testid="counter-section" className="py-20 md:py-28 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <p
          className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold text-[#E4077B] tracking-tight leading-none"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="counter-number"
        >
          +{count.toLocaleString("pt-BR")}
        </p>
        <p className="text-sm md:text-base tracking-[0.3em] uppercase text-[#555555] mt-4 font-medium">
          Festas Realizadas
        </p>
      </div>
    </section>
  );
}
